import { TypographyH4 } from "@/components/typography/H4";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { ArrowLeftCircle, BookMarked, ExternalLink } from "lucide-react";
import { CreateStandingOfferForm } from "./CreateStandingOfferForm";

export function CreateStandingOfferPage() {
  return (
    <div className="grid grid-cols-2 gap-x-20 gap-y-16 h-full place-content-center">
      <Link
        to="/organization/$organizationSlug/subscriptions"
        params={(prev) => ({ organizationSlug: prev.organizationSlug || "" })}
        search={{ view: "standing-offers" }}
      >
        <Button
          variant="outline"
          size="sm"
          className="place-self-start dark:text-brand-gray-300 hover:dark:text-brand-gray-100"
        >
          <ArrowLeftCircle className="w-4 h-4 inline mr-2" />
          Back
        </Button>
      </Link>
      <div className="row-start-2">
        <CreateStandingOfferForm />
      </div>
      <div className="row-start-2 rounded border dark:border-brand-gray-800 h-fit mt-24 p-6 grid grid-cols-[35px_1fr] gap-y-3 items-center">
        <BookMarked
          className="h-6 w-6 dark:text-brand-gray-600"
          strokeWidth="1.6"
        />
        <TypographyH4 className="col-start-2">Standing offers</TypographyH4>
        <TypographySM className="col-start-2 row-start-2 dark:text-brand-gray-400">
          Standing offers let you share an ongoing subscription to your app with
          no specified offer end date or individual user invitations. Multiple
          users can access an app through the same standing offer link. Users
          must be logged into Numerous to be able to subscribe and use the app.
          App administrators will be able to see all subscribers of their app.
          <br />
          <br />
          Standing offers can be cancelled at any time by the app administrator.
          If an app administrator wants to modify the subscription rate, past
          users&apos; subscriptions will not be affected. To modify subscription
          rates for past users, app administrators would need to cancel those
          users&apos; app subscriptions and provide a new offer with the new
          rate.
        </TypographySM>
        <a
          href="https://www.numerous.com/docs"
          className="col-start-2 row-start-3 place-self-end"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="ghost">
            Read more
            <ExternalLink className="w-4 h-4 ml-2 inline" />
          </Button>
        </a>
      </div>
    </div>
  );
}
